<template> 
    <main>
        <v-container class="grey lighten-4 fill-height" fluid>
                    <v-card class="elevation-12 ma-3 mx-auto">
                  <v-toolbar
                  color="primary"
                  dark
                  flat>
                  <v-toolbar-title>Skapa lösenord</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
        <v-form ref="form">
            <v-row>
                <v-col>
                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Din mail"
                    required
                    outlined
                ></v-text-field>
                </v-col>
                <v-col>
                <v-text-field
                    v-model="pin"
                    :rules="[e => e.length === 6 || 'Skriv in ett giltigt sex siffrig PIN']"
                    type="number"
                    label="STIFT"
                    required
                    outlined
                ></v-text-field>
                </v-col>
            </v-row>
            <v-text-field
                v-model="password"
                type="password"
                :rules="passRules"
                label="Lösenord"
                required
                outlined
            ></v-text-field>

            <v-text-field
                v-model="cnfpass"
                type="password"
                label="Bekräfta lösenord"
                :rules="[v => v === password || 'Lösenordet matchar inte']"
                required
                outlined
            ></v-text-field>

            <v-btn
                style="background-color:#ffa500"
                class="mr-4"
                v-on:click="submit"
                :loading="loading"
                block
            >
                Skicka in
                <v-icon style="margin-left:5px;font-size:15px">
                    fas fa-check
                </v-icon>
            </v-btn>
        </v-form>
                </v-card-text>
            </v-card>
        </v-container>
        <v-container v-show="!createmeeting" style="width:20%">
            <adds />
        </v-container>
    </main>
</template>

<script>
import store from "../../store";
export default {
    name: "setpassword",
    data: () => ({
      store:store,
        loading: false,
        email: "",
        cnfpass: "",
        password: "",
        pin: 0,
        passRules: [
            v => !!v || "lösenord krävs",
            v => v.length >= 8 || "Lösenordet måste vara större än 8 tecken"
        ],
        emailRules: [
            v => !!v || "din mail krävs",
            v => /.+@.+\..+/.test(v) || "Email måste vara giltig"
        ]
    }),
    methods: {
        validate: function() {
            this.$refs.form.validate();
        },
        submit: async function() {
            this.loading = true;
            if (this.$refs.form.validate()) {
                let bodyFormData = new FormData();
                bodyFormData.set("email", this.email);
                bodyFormData.set("password", this.password);
                bodyFormData.set("verification_code", parseInt(this.pin));
                const config = {
                    method: "post",
                    url: "",
                    headers: {
                        "Content-Type": "application/form-data;charset=utf-8",
                        "Access-Control-Allow-Origin": "*",
                        Accept: "*/*"
                    },
                    data: bodyFormData
                };
                try{
                await this.store.dispatch('setPassword', config);
                this.$router.replace('/login');
                }catch(err){
                    this.loading = false
                }
            }
            this.loading = false
        }
    }
};
</script>

<style></style>
